import React from 'react';
import { Lightbulb, Palette, Code, Settings } from 'lucide-react';

const OurServices = () => {
  const services = [
    {
      icon: Lightbulb,
      title: 'Brand Strategy',
      description: 'An operation aimed at building a brand that will capture a strategically valuable market.',
      details: [
        { subtitle: 'Discovery', items: ['Identify the need for change', 'Define key brand attributes', 'Get to know user personas', 'Formulate strategic goals'] },
        { subtitle: 'Identity system design', items: ['Design key visual elements of the brand', 'Build a brand collateral system', 'Create messaging architecture', 'Write a Brand Style Guide'] },
      ],
    },
    {
      icon: Palette,
      title: 'Design',
      description: 'An engineering approach to design, capable of solving business problems in unexpected ways.',
      details: [
        { subtitle: 'UI/UX', items: ['Rely on Brand Strategy and vision behind it', 'Build UX that helps the user and compliments the client', 'Build a maintainable design system', 'Create future-proof visuals', 'Design interactions'] },
        { subtitle: 'Illustration', items: ['Identify the purpose of the illustration', 'Describe the context in which it exists', 'Define the creative parameters for the artwork'] },
      ],
    },
    {
      icon: Code,
      title: 'Development',
      description: 'Complex integrated front-end and back-end development techniques, leveraging modern frameworks and libraries.',
      details: [
        { subtitle: 'Development', items: ['Build a solid infrastructural back-end base', 'Meticulously implement the front end', 'Extensively test the build', 'Apply DevOps to deploy and optimize'] },
      ],
    },
    {
      icon: Settings,
      title: 'Maintenance',
      description: "A set of post-launch activities to ensure stability, security, and reliability of the custom products we've built.",
      details: [
        { subtitle: 'SRE (Site Reliability Engineering)', items: ['Bring the Pillars team in', 'Run an evaluation report', 'Apply SRE practices'] },
      ],
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14 text-center">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
            Expertise
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading mb-4">
            Our accumulated professional skills
          </h2>
          <p className="text-lg text-slate-500 max-w-3xl mx-auto leading-relaxed">
            Cover all the needs of a digital product. Geek out below.
          </p>
        </div>

        <div className="space-y-12">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start p-7 sm:p-8 rounded-2xl border border-slate-100"
                style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}
              >
                <div>
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: 'rgba(38,147,255,0.08)' }}>
                      <Icon className="w-5 h-5" style={{ color: '#2693FF' }} />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 font-heading">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-slate-500 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <div className="space-y-6">
                  {service.details.map((detail, detailIndex) => (
                    <div key={detailIndex}>
                      <h4 className="text-base font-semibold text-slate-900 font-heading mb-3">
                        {detail.subtitle}
                      </h4>
                      <ul className="space-y-2">
                        {detail.items.map((item, itemIndex) => (
                          <li key={itemIndex} className="flex items-start gap-3 text-sm text-slate-500">
                            <span className="w-1.5 h-1.5 rounded-full flex-shrink-0 mt-1.5" style={{ background: '#2693FF' }} />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
